import classNames from 'classnames'
import React from 'react'
import styles from './index.module.scss'

interface IStars {
  starIcon: string
  starVacantIcon?: string
  maxScore?: number
  score: number
  className?: string
  starWidth?: number
  starHeight?: number
  marginRight?: number
}

export default function Stars(props: IStars) {
  const {
    starIcon,
    starVacantIcon,
    score,
    maxScore,
    className,
    starWidth = 13,
    starHeight = 12,
    marginRight = 0,
  } = props
  const stars = []
  for (let i = 1; i <= score; i++) {
    stars.push(0)
  }
  const intersection = score % 1
  if (intersection !== 0) {
    stars.push(1)
  }

  if (starVacantIcon && maxScore) {
    for (let i = Math.ceil(score); i < maxScore; i++) {
      stars.push(2)
    }
  }

  return (
    <div
      className={classNames(className, styles['stars-wrapper'])}
      style={
        {
          '--starWidth': starWidth,
          '--starHeight': starHeight,
          '--marginRight': marginRight,
          '--icon': `url(${starIcon})`,
          '--icon-vacant': `url(${starVacantIcon})`,
        } as React.CSSProperties
      }
    >
      {stars.map((ele, index) => {
        switch (ele) {
          case 0:
            return <span className={styles.star} key={index} />
          case 1:
            return (
              <span
                className={classNames(
                  styles['star-intersected'],
                  'star-intersected'
                )}
                key={index}
              />
            )
          case 2:
            return <span className={styles['star-vacant']} key={index} />
          default:
            return null
        }
      })}
      <style jsx>
        {`
          .star-intersected::after {
            content: '';
            background-image: url(${starVacantIcon});
            background-position: right;
            background-size: ${starWidth}px ${starHeight}px;
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: ${starWidth * (1 - intersection)}px;
          }
        `}
      </style>
    </div>
  )
}
